
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';

// Import Footer Components
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup';
import { elementInView } from './components/footer/elementInView';
import { faqs } from './components/footer/faqs';
import { navigation, navicon } from './components/footer/navigation';
import { smoothScrollToAnchor } from './components/footer/smoothScroll';
import { mapLoader } from './components/footer/mapLoader.js';
import { embedOverlay } from './components/footer/embedOverlay.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('video')) {
			document.querySelectorAll('video').forEach((video) => {
				if (video.querySelector('source') && video.querySelector('source').getAttribute('data-src')) {
					video.querySelectorAll('source').forEach((source) => {
						source.src = source.getAttribute('data-src');
					});
					video.load();
				}
				if (video.hasAttribute('autoplay')) {
					video.removeAttribute('controls');
					video.muted = true;
					video.play().catch(() => {
						video.addEventListener('click', () => {
							video.play();
						});
					});
				}
			});
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			const crmBlocks = document.querySelectorAll('.farlo-ui-crm[farlo-ui="crm"]');

			const toggleButton = document.querySelector('.farlo-ui-crm__toggle');
			const fixedContainer = document.createElement('div');
			fixedContainer.classList.add('farlo-ui-crm-toggle-container');
			const originalParent = toggleButton.parentNode;

			function moveToggleButton() {
				if (window.innerWidth <= 980) {
					if (toggleButton && fixedContainer && !fixedContainer.contains(toggleButton)) {
						fixedContainer.appendChild(toggleButton);
						document.querySelector('#page').appendChild(fixedContainer);
					}
				} else if (toggleButton && originalParent && !originalParent.contains(toggleButton)) {
					originalParent.appendChild(toggleButton);
				}
			}

			buttons.forEach(function(button) {
				let closestCrmBlock = null;
				let closestDistance = Infinity;

				crmBlocks.forEach(function(block) {
					const distance = button.getBoundingClientRect().top - block.getBoundingClientRect().top;
					if (distance > 0 && distance < closestDistance) {
						closestDistance = distance;
						closestCrmBlock = block;
					}
				});

				if (closestCrmBlock) {
					const crmId = closestCrmBlock.getAttribute('data-crm-id');
					button.setAttribute('data-crm-button-for', crmId);
				}
			});

			buttons.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});

			if (document.body.classList.contains('template-page-template-landingpage')) {
				window.addEventListener('resize', moveToggleButton);
				moveToggleButton();
			}
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScrollToAnchor(_sel);
		});

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('form')) {
			document.querySelector('form').querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('.farlo-ui-revolver-carousel').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}
	});
})(document, window, history);
